import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

type SearchHighlightedSnippetProps = {
  snippet: string
  query: string
  highlightClassName: string
}

export function SearchHighlightedSnippet({ snippet, query, highlightClassName }: SearchHighlightedSnippetProps) {
  const terms = query
    .trim()
    .split(/\s+/)
    .filter((term) => term.length > 0)

  if (terms.length === 0 || snippet.trim() === '') {
    return <>{snippet}</>
  }

  const escapedTerms = terms.map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  const splitRegex = new RegExp(`(${escapedTerms.join('|')})`, 'gi')
  const lowerTerms = new Set(terms.map((term) => term.toLowerCase()))

  return (
    <span data-testid={SEARCH_MODAL_TEST_IDS.highlightedSnippet}>
      {snippet.split(splitRegex).map((part, index) =>
        lowerTerms.has(part.toLowerCase()) ? (
          <mark key={`${part}-${String(index)}`} className={highlightClassName}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  )
}
